import { FilterPopover, NO_AUTOFILL, type Align, type SortProps } from './FilterPopover';
import { OptionChecklist } from './OptionChecklist';

export interface TextWithSelectValue {
  contains: string | null;
  selected: string[];
}

const EMPTY: TextWithSelectValue = { contains: null, selected: [] };

interface Props extends SortProps {
  label: string;
  align?: Align;
  value: TextWithSelectValue;
  options: string[];
  onChange: (next: TextWithSelectValue) => void;
  placeholder?: string;
}

/**
 * Code-like column (e.g. `user.login`): "contains" for a family of values,
 * plus a checklist of exact values. Both parts must match when both are set,
 * as in nge-fuel.
 */
export function TextWithSelectFilterPopover({
  label,
  align,
  value,
  options,
  onChange,
  placeholder = 'Contains…',
  ...sortProps
}: Props) {
  return (
    <FilterPopover<TextWithSelectValue>
      label={label}
      align={align}
      {...sortProps}
      filterActive={!!value.contains || value.selected.length > 0}
      value={value}
      emptyValue={EMPTY}
      onChange={(v) => onChange({ contains: v.contains?.trim() || null, selected: v.selected })}
      isEmpty={(d) => !d.contains?.trim() && d.selected.length === 0}
      width="18rem"
      render={({ draft, setDraft }) => (
        <div className="column-filter-stack">
          <div>
            <div className="column-filter-field-label">Contains</div>
            <input
              type="text"
              className="column-filter-input"
              {...NO_AUTOFILL}
              value={draft.contains ?? ''}
              onChange={(e) => setDraft({ ...draft, contains: e.target.value || null })}
              placeholder={placeholder}
              autoFocus
            />
          </div>
          <div className="column-filter-divider" />
          <OptionChecklist
            options={options.map((o) => ({ value: o, label: o }))}
            selected={draft.selected}
            onChange={(selected) => setDraft({ ...draft, selected })}
            heading="Exact values"
            searchable
            mono
          />
        </div>
      )}
    />
  );
}
